import { track } from './eventTracking.service';

let listener = null;

function findTrackable(target) {
  let el = target;
  while (el && el !== document.body) {
    if (el.dataset && el.dataset.track) return el;
    el = el.parentElement;
  }
  return null;
}

export function startClickTracker() {
  if (listener) return;
  listener = (ev) => {
    const el = findTrackable(ev.target);
    if (!el) return;
    const props = { id: el.dataset.track };
    for (const key of Object.keys(el.dataset)) {
      if (/^track[A-Z]/.test(key)) {
        const propKey = key.slice(5).replace(/^[A-Z]/, c => c.toLowerCase());
        props[propKey] = el.dataset[key];
      }
    }
    track('click', props);
  };
  document.addEventListener('click', listener, true);
}

export function stopClickTracker() {
  if (!listener) return;
  document.removeEventListener('click', listener, true);
  listener = null;
}
